import watchCreateLayout from './createLayout';
import watchDeleteLayout from './deleteLayout';
import watchFetchLayoutsSaga from './fetchLayouts';
import watchSaveLayout from './saveLayout';

const layoutSagas = [watchCreateLayout(), watchDeleteLayout(), watchFetchLayoutsSaga(), watchSaveLayout()];
export default layoutSagas;
